import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'normalizeKey',
    standalone: false
})
export class NormalizeKeyPipe implements PipeTransform {
    transform(value: unknown): string {
        return String(value ?? '').trim().toLowerCase().replace(/[^a-z0-9]/g, '');
    }
}
